import React from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styles from "./ReviewSummaryView.module.scss";
const SharingConfirmationSummary = ({ t, i18n, setIsError }) => {
  const navigate = useNavigate();
  const { questionDataList } = useSelector((state) => state?.app);
  const editSignatureOnClick = (e) => {
    e.preventDefault();
    try {
      navigate(
        `/${i18n.language}${t("routes.consent_to_share")}?isSummary=true`
      );
    } catch (e) {
      console.log(e);
      setIsError(true);
    }
  };
  return (
    <div className="row">
      <div className="col-xs-12 col-lg-9">
        <div className="col-xs-12">
          <div className="row" style={{ display: "flex", flexGrow: 1 }}>
            <div
              style={{
                display: "flex",
                flexGrow: 1,
                justifyContent: "flex-start",
                alignItems: "center"
              }}
            >
              <div style={{ margin: '0px 6px' }}>
                <h3>{t("review_summary.confirmation_agreement")}</h3>
              </div>
              <div style={{ margin: '0px 1em' }}>
                <a
                  id="edit-another-adult"
                  href="#"
                  className={[styles["edit_button"]].join(" ")}
                  onClick={editSignatureOnClick}
                  value={t("shared.edit")}
                  name={t("shared.edit")}
                >
                  <i
                    aria-label={t("shared.edit")}
                    className="fa fa-pencil-alt"
                    aria-hidden="true"
                  ></i>
                  {t("shared.edit")}
                </a>
              </div>
            </div>
          </div>

          <div className="row" style={{ display: "flex", flexGrow: 1 }}>
            <div className="col-xs-12 col-md-8">
              <strong>{t("review_summary.agreement_statement1")}</strong>
            </div>
            <div className="col-xs-12 col-md-4">
              {t("review_summary.agreed")}
            </div>
          </div>

          <hr />
        </div>
      </div>
    </div>
  );
};

export default withTranslation("common")(SharingConfirmationSummary);
